var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_82_154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.1504 9.02979C30.1004 9.02979 21.6724 16.7895 15.0505 21.0697L21.0704 27.0898L0.000488281 36.1197L21.0704 45.1497L15.0504 51.1698C21.6724 55.45 33.1105 63.2097 45.1504 63.2097C60.1118 63.2097 72.2403 51.0811 72.2403 36.1197C72.2403 21.1583 60.1118 9.02979 45.1504 9.02979ZM45.1504 54.1797C35.1762 54.1797 27.0904 46.0939 27.0904 36.1197C27.0904 26.1456 35.1762 18.0598 45.1504 18.0598C55.1246 18.0598 63.2104 26.1456 63.2104 36.1197C63.1988 46.0891 55.1198 54.1681 45.1504 54.1797Z",
    fill: "#B82428"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3349 32.6763L37.0718 30.2682L35.1665 35.9872L44.1965 38.9971C45.2782 39.3518 46.4675 39.0705 47.2757 38.2687L56.3057 29.2387L52.0526 24.9614L44.3349 32.6763Z",
    fill: "#B82428"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0404 15.0498H0.000488281V21.0698H12.0404V15.0498Z",
    fill: "#B82428"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0404 51.1699H0.000488281V57.19H12.0404V51.1699Z",
    fill: "#B82428"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0805 3.00977H12.0405V9.0298H24.0805V3.00977Z",
    fill: "#B82428"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0805 63.2095H12.0405V69.2295H24.0805V63.2095Z",
    fill: "#B82428"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_82_154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72.2399,
    height: 72.2399,
    fill: "white",
    transform: "translate(0.000488281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNow);
export default __webpack_public_path__ + "static/media/now.fef0f09f12732dd1309e2108c589616a.svg";
export { ForwardRef as ReactComponent };